import axios from 'axios';

export default (config = {}) => {

  const defaultConfig = {};

  return axios.create({ ...defaultConfig, ...config });
};